import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import axios from 'axios';
import { Template_list_columns, toCamelCase } from "../components/ApiProperty";
import { FaArrowUp, FaArrowDown, FaAngleDoubleUp, FaAngleDoubleDown, FaArrowRight, FaArrowLeft, FaAngleDoubleRight, FaAngleDoubleLeft } from 'react-icons/fa';

const GapsyIneractiveBuilderManual = () => {
    const navigate = useNavigate();
    const [box1Columns, setBox1Columns] = useState([]);
    const [box2Columns, setBox2Columns] = useState([]);
    const [searchTermBox1, setSearchTermBox1] = useState('');
    const [searchTermBox2, setSearchTermBox2] = useState('');
    const [templateData, setTemplateData] = useState([]);
    const [bulkButtonDirection, setBulkButtonDirection] = useState('right'); // Bulk button direction state
    const [columnCount, setColumnCount] = useState(0);

    const columnsContainerRef = useRef(null); // Reference to the columns container
    let csrfToken = sessionStorage.getItem("tokenizedSession");

    const apiSessionId = sessionStorage.getItem("sessionId");

    useEffect(() => {
        const fetchColumns = async () => {
            try {
                const config = {
                    params: { "adminId": localStorage.getItem('userid') },
                    headers: {
                        "x-csrf-token": csrfToken
                    },
                    withCredentials: true,
                };
                // const response = await axios.post('http://172.16.119.156:8081/api/rb/template_list_columns', {}, config);
                const response = await axios.post(Template_list_columns, {}, config);

                const initialColumns = response.data.columns.map(col => ({ id: col.col_name, name: col.col_label, selected: false }));
                setBox1Columns(initialColumns);
                setTemplateData(response.data.columns);
                setColumnCount(response.data.columns.length);
            } catch (error) {
                console.error('There was an error fetching the columns!', error);
            }
        };
        fetchColumns();
    }, []);

    const handleAddToBox2 = () => {
        const selectedColumns = box1Columns.filter(col => col.selected);
        // Move selected columns to Box2
        setBox2Columns(prev => [...prev, ...selectedColumns.map(col => ({ ...col, selected: false }))]);
        // Remove moved columns from Box1
        setBox1Columns(box1Columns.filter(col => !col.selected));
    };


    const handleRemoveFromBox2 = () => {
        const selectedColumnsFromBox2 = box2Columns.filter(col => col.selected);
        // Move selected columns back to Box1
        setBox1Columns(prev => [...prev, ...selectedColumnsFromBox2.map(col => ({ ...col, selected: false }))]);
        // Remove moved columns from Box2
        setBox2Columns(box2Columns.filter(col => !col.selected));
    };

    const handleBulkMoveToBox2 = () => {
        setBox2Columns(prev => [...prev, ...box1Columns.map(col => ({ ...col, selected: false }))]);
        setBox1Columns([]);
    };

    const handleBulkMoveToBox1 = () => {
        // Move all columns from box2 back to box1
        setBox1Columns(prev => [
            ...prev,
            ...box2Columns.map(col => ({ ...col, selected: false })) // Move columns back to box1 and reset selection
        ]);
        setBox2Columns([]); // Clear box2 after moving all columns back to box1
    };

    // Deselect all columns when clicking outside the container
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (
                columnsContainerRef.current &&
                !columnsContainerRef.current.contains(event.target)
            ) {
                // Deselect all selected columns
                setBox1Columns((prev) =>
                    prev.map((col) => ({ ...col, selected: false }))
                );
                setBox2Columns((prev) =>
                    prev.map((col) => ({ ...col, selected: false }))
                );
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const toggleBulkButtonDirection = () => {
        if (anySelectedBox1) {
            handleBulkMoveToBox2(); // Move all columns to Box2
            setBulkButtonDirection('left'); // Update direction to "left"
        } else if (anySelectedBox2) {
            handleBulkMoveToBox1(); // Move all columns back to Box1
            setBulkButtonDirection('right'); // Update direction to "right"
        } else {
            // Default behavior in case no selections exist
            setBulkButtonDirection('right');
        }
    };

    const handleDragStart = (e, col, boxNumber) => {
        // Set the dragged column's `col_name` and box number in the dataTransfer
        e.dataTransfer.setData('text/plain', JSON.stringify({ id: col.col_name, boxNumber }));
        e.target.classList.add('dragging');
    };

    const handleDragEnd = (e) => {
        e.target.classList.remove('dragging');
    };

    const handleDrop = (e, boxNumber) => {
        e.preventDefault();

        // Get the dragged data (which contains the column id and box number)
        const data = JSON.parse(e.dataTransfer.getData('text/plain'));
        const column = templateData.find(col => col.col_name === data.id);  // Find the column based on col_name

        if (boxNumber === 2 && column) {
            // Move the column to box 2 (right side) and mark it as selected=false (no need to mark it selected here)
            setBox2Columns(prev => [
                ...prev,
                { id: column.col_name, name: column.col_label, selected: false } // No need to change selected status
            ]);

            // Remove the column from box 1 (left side)
            setBox1Columns(prev => prev.filter(col => col.col_name !== data.id));
        } else if (boxNumber === 1 && column) {
            // Move the column to box 1 (left side)
            setBox1Columns(prev => [
                ...prev,
                { id: column.col_name, name: column.col_label, selected: false }
            ]);

            // Remove the column from box 2 (right side)
            setBox2Columns(prev => prev.filter(col => col.col_name !== data.id));
        }
    };


    const handleDragOver = (e) => e.preventDefault();

    const toggleColumnSelection = (col, boxNumber, event) => {
        const setBoxColumns = boxNumber === 1 ? setBox1Columns : setBox2Columns;
        const isCtrlOrCmd = event.ctrlKey || event.metaKey; // Check if Ctrl or Cmd is pressed

        if (isCtrlOrCmd) {
            // Toggle multiple selections when Ctrl/Cmd is pressed
            setBoxColumns(columns =>
                columns.map(c =>
                    c.id === col.id ? { ...c, selected: !c.selected } : c
                )
            );
        } else {
            // Single selection when Ctrl/Cmd is not pressed
            setBoxColumns(columns =>
                columns.map(c => {
                    if (c.id === col.id) {
                        return { ...c, selected: !c.selected };
                    } else {
                        return { ...c, selected: false }; // Deselect other columns
                    }
                })
            );
        }
    };




  const handleClearSelection = () => {
    // Reset box1Columns with the original fetched data (templateData) and ensure no columns are selected
    const resetBox1Columns = templateData.map(col => ({
      id: col.col_name,
      name: col.col_label,
      selected: false
    }));

    // Set box1Columns back to the initial state and clear box2Columns
    setBox1Columns(resetBox1Columns);
    setBox2Columns([]); // Clear selected columns
    setBulkButtonDirection('right');
  };



  const createTable = () => {
    let tableHtml = '<table class="table table-bordered"><thead class="thead-light"><tr>';
    const headers = Object.keys(templateData[0] || {});
    headers.forEach(header => tableHtml += `<th>${header}</th>`);
    tableHtml += '</tr></thead><tbody>';
    box2Columns.forEach(col => {
      const rowData = templateData.find(data => data.col_name === col.id);
      if (rowData) {
        tableHtml += '<tr>';
        headers.forEach(header => {
          // Check if the column type is DATE
          const cellValue = rowData[header];
          const colType = rowData.col_type; // Assuming you have the `col_type` in the rowData
          const displayValue = colType === ('DATE' && 'DECIMAL') && (cellValue === null || cellValue === undefined) ? '' : cellValue;

          tableHtml += `<td>${displayValue !== undefined ? displayValue : ''}</td>`;
        });
        tableHtml += '</tr>';
      }
    });

    tableHtml += '</tbody></table>';
    return tableHtml;
  };


  const handleNavigateToTableDetails = () => {
    const tableHtml = createTable();
    navigate('/gapsyibmCreate', { state: { tableHtml } });
  };

    const filteredColumnsBox1 = box1Columns.filter(col => col.name.toLowerCase().includes(searchTermBox1.toLowerCase()));
    const filteredColumnsBox2 = box2Columns.filter(col => col.name.toLowerCase().includes(searchTermBox2.toLowerCase()));


    const anySelectedBox1 = box1Columns.some(col => col.selected);
    const anySelectedBox2 = box2Columns.some(col => col.selected);

    // Determine button text based on selection
    const buttonText = anySelectedBox1 ? '>' : anySelectedBox2 ? '<' : '>';
    const bulkButtonText = anySelectedBox1 ? '>>' : anySelectedBox2 ? '<<' : '>>';


    const moveColumn = (index, direction) => {
        if (index < 0 || index >= box2Columns.length) return; // Prevent out-of-bound moves
        const newColumns = [...box2Columns];
        const newIndex = index + direction;

        // Check if the newIndex is within bounds
        if (newIndex >= 0 && newIndex < newColumns.length) {
            const [movedColumn] = newColumns.splice(index, 1);  // Remove the column at the current index
            newColumns.splice(newIndex, 0, movedColumn);  // Insert it at the new index
            setBox2Columns(newColumns);
        }
    };


    const moveToExtreme = (index, position) => {
        if (index < 0 || index >= box2Columns.length) return; // Prevent out-of-bound moves

        const newColumns = [...box2Columns];
        const [movedColumn] = newColumns.splice(index, 1); // Remove the selected column

        if (position === 'top') {
            // Insert at the beginning
            newColumns.unshift(movedColumn);
        } else if (position === 'bottom') {
            // Insert at the end
            newColumns.push(movedColumn);
        }

        setBox2Columns(newColumns);
    };


    const handleDoubleClickMoveToBox2 = (column) => {
        if (!anySelectedBox2) {
            // Call the function you already have to handle moving columns
            handleAddToBox2(column);
        }
    };


    const handleDoubleClickMoveToBox1 = (column) => {
        if (!anySelectedBox1) {
            // Call the function you already have to handle moving columns
            handleRemoveFromBox2(column);
        }
    };

    const handleDashboard = () => {
        navigate('/gapsyAdashboard');
    };

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className={`breadcrumb-item`}>
                                    <a onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{cursor: "pointer"}}></i>/
                                    </a>
                                    {/* <span className={styles.separator}></span> */}
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-grid me-2"></i>1.2 Interactive Builder
                                </li>

                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid h-100">
                <div className={styles.mainContainer}>
                    <div className="container-fluid">
                        <div className={`${styles.containerRow} row justify-content-center`} ref={columnsContainerRef}>
                            <div className="position-relative">
                                <h6 className={`${styles.borderBottom}`}>Interactive Builder</h6>
                            </div>
                            <div className="col-lg-4 col-md-12" >
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card} ${styles.scrollableCard}`}>
                                    <div className="card-header bg-transparent">
                                        <h6 className="mb-0">Default columns ({columnCount})</h6>
                                    </div>
                                    <div className="mx-2 my-1">
                                        <input
                                            type="text"
                                            placeholder="Search columns..."
                                            value={searchTermBox1}
                                            onChange={(e) => setSearchTermBox1(e.target.value)}
                                            className="form-control form-control-sm"
                                        />
                                    </div>
                                    <div className={`card-body pt-0 ${styles.scrollableBody}`}>
                                        <ul className="list-group card-list-bdm" style={{ marginBottom: '5px' }}>
                                            {filteredColumnsBox1.map((col, index) => (
                                                <li
                                                    key={index}
                                                    className={`list-group ${styles.ibmListGroup1} ${col.selected && !anySelectedBox2 ? styles.ibmActiveColumn : ''}`}
                                                    draggable
                                                    onDragStart={(e) => handleDragStart(e, col, 1)}
                                                    onDragEnd={handleDragEnd}
                                                    onClick={(e) => {
                                                        if (!anySelectedBox2) {
                                                            toggleColumnSelection(col, 1, e);
                                                        }
                                                    }}
                                                    onDoubleClick={() => {
                                                        if (!anySelectedBox2) {
                                                            handleDoubleClickMoveToBox2(col);
                                                        }
                                                    }}>
                                                    {toCamelCase(col.name)}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-1 col-md-12 d-flex flex-column align-items-center justify-content-center">
                                <button
                                    className="btn btn-sm btn-primary mb-2"
                                    onClick={() => {
                                        if (buttonText === '>') {
                                            handleAddToBox2();
                                        } else if (buttonText === '<') {
                                            handleRemoveFromBox2();
                                        }
                                    }}
                                    disabled={!anySelectedBox1 && !anySelectedBox2}
                                    title="Move a selected column"
                                >
                                    {buttonText === '>' ? <FaArrowRight size={13} /> : <FaArrowLeft size={13} />}
                                </button>
                                <button
                                    className="btn btn-sm btn-primary mb-2"

                                    onClick={toggleBulkButtonDirection}
                                    title="Move all columns"
                                >
                                    {bulkButtonText === '>>' ? <FaAngleDoubleRight size={14} /> : <FaAngleDoubleLeft size={14} />}
                                </button>

                            </div>
                            <div className="col-lg-4 col-md-12" >
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card} ${styles.scrollableCard}`} onDrop={(e) => handleDrop(e, 2)} onDragOver={handleDragOver}>
                                    <div className="card-header bg-transparent">
                                        <h6 className="mb-0">Selected Columns ({box2Columns.length})</h6>
                                    </div>
                                    <div className="mx-2 my-1">
                                        <input
                                            type="text"
                                            placeholder="Search columns..."
                                            value={searchTermBox2}
                                            onChange={(e) => setSearchTermBox2(e.target.value)}
                                            className="form-control form-control-sm"
                                        />
                                    </div>

                                    <div className={`card-body pt-0 ${styles.scrollableBody}`}>
                                        <ul className="list-group card-list-bdm">
                                            {filteredColumnsBox2.map((col, index) => (
                                                <li
                                                    key={index}
                                                    className={`list-group ${styles.ibmListGroup2} ${col.selected ? styles.ibmActiveColumn : ''}`}
                                                    draggable
                                                    onDragStart={(e) => handleDragStart(e, col, 2)}
                                                    onDragEnd={handleDragEnd}
                                                    onClick={(e) => toggleColumnSelection(col, 2, e)}
                                                    onDoubleClick={() => handleDoubleClickMoveToBox1(col)} // Move to Box1 on double-click
                                                >
                                                    {toCamelCase(col.name)}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="card-footer text-center d-flex justify-content-center" style={{ padding: '1px', gap: '1px' }}>
                                        {/* Move Up */}
                                        <button
                                            className="btn custom-btn1 mx-2"
                                            onClick={() => moveColumn(box2Columns.findIndex(col => col.selected), -1)}
                                            disabled={filteredColumnsBox2.findIndex(col => col.selected) <= 0}
                                            title="Move Up"
                                        >
                                            {/* &uarr; */}
                                            <FaArrowUp />
                                        </button>

                                        {/* Move Down */}
                                        <button
                                            className="btn custom-btn1 mx-2"
                                            onClick={() => moveColumn(box2Columns.findIndex(col => col.selected), 1)}
                                            disabled={filteredColumnsBox2.findIndex(col => col.selected) >= filteredColumnsBox2.length - 1}
                                            title="Move Down"
                                        >
                                            {/* &darr; */}
                                            <FaArrowDown />
                                        </button>

                                        {/* Move to Top */}
                                        <button
                                            className="btn custom-btn1 mx-2"
                                            onClick={() => moveToExtreme(box2Columns.findIndex(col => col.selected), 'top')}
                                            disabled={filteredColumnsBox2.findIndex(col => col.selected) <= 0}
                                            title="Move to Top"
                                        >

                                            <FaAngleDoubleUp />
                                        </button>

                                        {/* Move to Bottom */}
                                        <button
                                            className="btn custom-btn1 mx-2"
                                            onClick={() => moveToExtreme(box2Columns.findIndex(col => col.selected), 'bottom')}
                                            disabled={filteredColumnsBox2.findIndex(col => col.selected) >= filteredColumnsBox2.length - 1}
                                            title="Move to Bottom"
                                        >
                                            <FaAngleDoubleDown />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col d-flex justify-content-center">
                                    <button className="btn btn-sm btn-outline-secondary mx-2" onClick={handleClearSelection}
                                        title="Reset the selected columns">Clear</button>
                                        
                                    <button className="btn btn-sm btn-outline-primary mx-2" onClick={handleNavigateToTableDetails}
                                        disabled={filteredColumnsBox2.length === 0} title="Next">Next</button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyIneractiveBuilderManual;
